module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./EvaluateView.js"));
	}, "EvaluateView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=EvaluateView!./src/pages/Shop/Member/Personal/ServiceCode/Evaluate/EvaluateView.js
// module id = 1470
// module chunks = 418